import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["idInput", "passportInput", "submit", "message"]

  inputChanged() {
    this.enableSubmission()
  }

  enableSubmission() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }
    this.messageTargets.forEach((element) => {
      element.classList.add("hidden")
    })
  }
}
